module.exports = __webpack_public_path__ + "img/0Q3A5468_L_Black_MockedUp.ea99d255.jpg";